import { render, staticRenderFns } from "./n-section-empty.vue?vue&type=template&id=0bc73fdc&scoped=true&"
import script from "./n-section-empty.vue?vue&type=script&lang=js&"
export * from "./n-section-empty.vue?vue&type=script&lang=js&"
import style0 from "./n-section-empty.vue?vue&type=style&index=0&id=0bc73fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc73fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Vuejs-Project\\subsappadminOrg\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc73fdc')) {
      api.createRecord('0bc73fdc', component.options)
    } else {
      api.reload('0bc73fdc', component.options)
    }
    module.hot.accept("./n-section-empty.vue?vue&type=template&id=0bc73fdc&scoped=true&", function () {
      api.rerender('0bc73fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/n-section-empty/n-section-empty.vue"
export default component.exports